import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param lat Number
 * @return {Promise<any>|Promise}
 */
export default (function (lat, lon) {
    var url = applyPathVariables(EndPoints.AZURE_MAPS_REVERSE_ADDRESS, { lat: lat, lng: lon });
    var request = new Request({ method: Methods.GET, url: url, withCredentials: false, ignorePrefix: true });
    return request.execute();
});
